import { Route } from 'vue-router'
import { Dictionary } from 'vue-router/types/router'

export function parse (param: string, value: string): number {
  if (value === undefined) {
    throw new Error(`Param "${param}" was not received`)
  }

  const parsed = parseInt(value, 10)

  if (isNaN(parsed)) {
    throw new Error(`Could not parse "${param}", received "${value}"`)
  }

  return parsed
}

/**
 * Parses a Route param to number.
 *
 * @param param Route param that will be parsed.
 */
export function parseId (param: string) {
  return function (route: Route) {
    const value = route.params[param]

    return {
      ...route.params,
      [param]: parse(param, value)
    }
  }
}

/**
 * Parses a Route params to number.
 *
 * @param params Route params that will be parsed.
 */
export function parseIds (params: string[]) {
  return function (route: Route) {
    const dictionary: Dictionary<number> = {}

    for (const param of params) {
      const value = route.params[param]
      dictionary[param] = parse(param, value)
    }

    return {
      ...route.params,
      ...dictionary
    }
  }
}
